import { type UseQueryResult, useQuery } from 'react-query';
import {
  NotificationTemplateService,
  PagedResultDto_NotificationMatrixTemplateDto,
} from '../../services/wealthlane-notification-services';
import { TableParams } from '../../types/common';

const useGetEmailTemplates = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<PagedResultDto_NotificationMatrixTemplateDto | undefined, unknown> => {
  const {
    notificationMediumIds,
    notificationCategories,
    filter,
    isActive,
    sorting,
    skipCount,
    maxResultCount,
  } = tableInfo;

  return useQuery(
    [
      'getEmailTemplates',
      notificationMediumIds,
      notificationCategories,
      filter,
      isActive,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        NotificationTemplateService.getApiNotificationApiAppNotificationTemplate(
          null,
          [notificationMediumIds],
          [notificationCategories],
          filter,
          isActive,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );
};

export default useGetEmailTemplates;
